const ImageCard = ({imageurl}) => {
    return (
      <div>
        <img src={imageurl.image_url} alt=""  />
      </div>
    );
}
 
export default ImageCard;